// extracted by mini-css-extract-plugin
export default {"questionText":"Q_cK","info":"Q_cL","question":"Q_cM"};